import { ColumnDef } from '@tanstack/react-table';
import get from 'lodash/get';
import { ContentAlignment, TableColumn } from '../..';
import { CellTypeStrategy } from '../models';
import { StringCellRenderer } from './StringCellRenderer';

export class StringCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef(col: TableColumn<TData>): Partial<ColumnDef<TData>> {
    return {
      accessorFn: (row: TData, index: number) => {
        const value = get(row, col.id);
        return value != null ? String(value) : null;
      },
      cell: StringCellRenderer,
      meta: {
        align: ContentAlignment.LEFT,
      },
    };
  }
}
